module.exports = __webpack_public_path__ + "img/symbol_14_normal.85c1596e.png";